import { Dialog, DialogContent, DialogActions, Typography, Stack, Button, Box } from '@mui/material';
import { toast } from 'react-toastify';
import Icon from '@/units/Icon';
import { useNotesContext } from '../../hooks/useNotesContext';

interface CompleteNoteModalProps {
  completeNote: (noteId: number) => void;
}

export const CompleteNoteModal: React.FC<CompleteNoteModalProps> = ({ completeNote }) => {
  const { currentAction, setCurrentAction, userId, collaborators } = useNotesContext();
  const isOpen = !!currentAction && currentAction.type === 'change-status' && !!currentAction.note;
  const selectedNote = currentAction?.note;
  const foundUser = collaborators?.find((c) => c.id === userId);

  const handleConfirm = async (e) => {
    e.stopPropagation();
    if (!selectedNote) return;

    if (foundUser.id !== selectedNote?.userId) {
      toast.error('Only user, who creted this Note can mark it as complete');
      setCurrentAction(null);
      return;
    }

    await completeNote(selectedNote.id);
    currentAction.onSuccess?.();
    setCurrentAction(null);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => setCurrentAction(null)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-paper': { background: 'transparent', borderRadius: '12px' },
        '& .MuiBackdrop-root': {
          background: 'rgba(0, 0, 0, 0.40)',
          backdropFilter: 'blur(8px)',
        },
      }}
    >
      <Stack sx={{ maxWidth: '400px', background: 'white', borderRadius: '12px' }}>
        <DialogContent>
          <Box display="flex" alignItems="start" justifyContent="flex-start" paddingBottom={2}>
            <Icon.Attention style={{ fontSize: 40 }} />
          </Box>
          <Typography variant="h6" align="left" gutterBottom>
            Mark as completed?
          </Typography>
          <Typography variant="body2" align="left" color="textSecondary">
            Are you sure you want to mark this note as completed? You can find and restore the note from archive later.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Stack direction="row" spacing={2} justifyContent="center" width="100%" padding={2}>
            <Button variant="outlined" onClick={() => setCurrentAction(null)} style={{ width: 120 }}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleConfirm} color="primary" style={{ width: 120 }}>
              Confirm
            </Button>
          </Stack>
        </DialogActions>
      </Stack>
    </Dialog>
  );
};
